import type { InternalAxiosRequestConfig } from 'axios';
import { URLS } from '@/shared/config/urls';
import { isTsdbPath } from './tsdbPaths';
import { useTsdbStore } from './tsdbStore';

// api-dsh serves TimescaleDB copies of these Elasticsearch-backed GETs under /tsdb.
const TSDB_API_PREFIX = '/tsdb';
const ENDPOINTS: { label: string; pattern: RegExp }[] = [
  { label: '/ambulance/list', pattern: /^\/ambulance\/list$/ },
  { label: '/ambulance/route/list', pattern: /^\/ambulance\/route\/list$/ },
  { label: '/ambulance-report/<id>/ambulance', pattern: /^\/ambulance-report\/\d+\/ambulance$/ },
  { label: '/map/poi', pattern: /^\/map\/poi$/ },
  { label: '/event', pattern: /^\/event$/ },
  { label: '/event/<type>/<id>', pattern: /^\/event\/[^/]+\/[^/]+$/ },
  { label: '/dashboard/anomaly/trend', pattern: /^\/dashboard\/anomaly\/trend$/ },
  { label: '/site/<id>/weather', pattern: /^\/site\/[^/]+\/weather$/ },
  {
    label: '/traffic-volume/*',
    pattern:
      /^\/traffic-volume\/(by-vehicle|by-vehicle\/hourly|congestion|congestion\/by-location|trend|export)$/,
  },
  {
    label: '/traffic/*',
    pattern: /^\/traffic\/(trend|vehicle-count|event|event\/summary|event\/export|cctv\/export)$/,
  },
];

const matchEndpoint = (path: string): string | undefined => {
  const endpoint = ENDPOINTS.find(({ pattern }) => pattern.test(path));
  return endpoint && (endpoint.label.endsWith('/*') ? path : endpoint.label);
};

/** On a /dashboard/tsdb page, point the copied GET endpoints at /api/dsh/tsdb. */
export const rewriteForTsdb = (config: InternalAxiosRequestConfig): void => {
  if (!config.url || (config.method ?? 'get').toLowerCase() !== 'get') return;
  if (!isTsdbPath(window.location.pathname)) return;

  const base = URLS.BACK_DSH;
  const absolute = config.url.startsWith(base);
  const relative = absolute ? config.url.slice(base.length) : config.url;
  if (!relative.startsWith('/')) return;

  const [path = ''] = relative.split('?');
  const endpoint = matchEndpoint(path);
  if (!endpoint) return;

  config.url = `${absolute ? base : ''}${TSDB_API_PREFIX}${relative}`;
  useTsdbStore.getState().record(endpoint);
};
